{
 "id": "kelmore",
 "name": "Kelmore Forest",
 "kind": "road",
 "description": "Fictional 5 km mixed-surface special stage: flowing forest, a hairpin climb, open hillside with crests and a jump, a long straight, a hamlet on broken tarmac with square junctions, a ford and a narrow bridge, then tight forest to a flying finish.",
 "seed": 20261009,
 "environment": {
  "sunElevationDeg": 34,
  "sunAzimuthDeg": 228,
  "turbidity": 3.2,
  "rayleigh": 1.4,
  "fogColor": [
   0.66,
   0.73,
   0.8
  ],
  "fogNear": 140,
  "fogFar": 1500,
  "heightFogDensity": 0.02,
  "cloudCoverage": 0.35,
  "exposure": 1
 },
 "centerline": [
  {
   "x": 0,
   "z": 0,
   "y": 120,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": 0,
   "z": 12,
   "y": 120,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": 0,
   "z": 24,
   "y": 120,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": 0,
   "z": 36,
   "y": 120,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": 0,
   "z": 48,
   "y": 120,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": 0,
   "z": 60,
   "y": 120,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": 0,
   "z": 72,
   "y": 120,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": 0,
   "z": 84,
   "y": 120,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": 0,
   "z": 96,
   "y": 120,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": 0,
   "z": 108,
   "y": 120,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": 0,
   "z": 120,
   "y": 120,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": 0,
   "z": 132,
   "y": 120,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": 0,
   "z": 144,
   "y": 120,
   "width": 6.2,
   "camber": 0.001
  },
  {
   "x": -0.05,
   "z": 156,
   "y": 120,
   "width": 6.2,
   "camber": 0.002
  },
  {
   "x": -0.29,
   "z": 168,
   "y": 120,
   "width": 6.2,
   "camber": 0.004
  },
  {
   "x": -0.83,
   "z": 179.98,
   "y": 120,
   "width": 6.2,
   "camber": 0.005
  },
  {
   "x": -1.81,
   "z": 191.94,
   "y": 120,
   "width": 6.2,
   "camber": 0.005
  },
  {
   "x": -3.23,
   "z": 203.86,
   "y": 120,
   "width": 6.2,
   "camber": 0.005
  },
  {
   "x": -5.1,
   "z": 215.71,
   "y": 120,
   "width": 6.2,
   "camber": 0.005
  },
  {
   "x": -7.41,
   "z": 227.49,
   "y": 120,
   "width": 6.2,
   "camber": 0.005
  },
  {
   "x": -10.14,
   "z": 239.17,
   "y": 120,
   "width": 6.2,
   "camber": 0.004
  },
  {
   "x": -13.2,
   "z": 250.77,
   "y": 120.01,
   "width": 6.2,
   "camber": 0.002
  },
  {
   "x": -16.44,
   "z": 262.33,
   "y": 120.05,
   "width": 6.2,
   "camber": 0.001
  },
  {
   "x": -19.75,
   "z": 273.86,
   "y": 120.11,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -23.05,
   "z": 285.4,
   "y": 120.2,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -26.36,
   "z": 296.93,
   "y": 120.31,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -28.98,
   "z": 306.07,
   "y": 120.4,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -30.08,
   "z": 309.91,
   "y": 120.76,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -31.19,
   "z": 313.76,
   "y": 120.6,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -34.49,
   "z": 325.29,
   "y": 120.6,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -37.8,
   "z": 336.83,
   "y": 120.72,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -41.11,
   "z": 348.36,
   "y": 120.84,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -44.14,
   "z": 358.94,
   "y": 120.95,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -45.24,
   "z": 362.78,
   "y": 121.14,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -46.62,
   "z": 367.59,
   "y": 121.66,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -47.72,
   "z": 371.43,
   "y": 122.01,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -48.83,
   "z": 375.28,
   "y": 122.05,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -49.93,
   "z": 379.12,
   "y": 121.44,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -53.24,
   "z": 390.66,
   "y": 121.28,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -56.54,
   "z": 402.19,
   "y": 121.4,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -59.85,
   "z": 413.73,
   "y": 121.52,
   "width": 6.2,
   "camber": -0.001
  },
  {
   "x": -63.09,
   "z": 425.28,
   "y": 121.64,
   "width": 6.2,
   "camber": -0.004
  },
  {
   "x": -66,
   "z": 436.92,
   "y": 121.76,
   "width": 6.2,
   "camber": -0.007
  },
  {
   "x": -68.3,
   "z": 448.7,
   "y": 121.88,
   "width": 6.2,
   "camber": -0.01
  },
  {
   "x": -69.72,
   "z": 460.61,
   "y": 122,
   "width": 6.2,
   "camber": -0.011
  },
  {
   "x": -70.19,
   "z": 472.6,
   "y": 122.12,
   "width": 6.2,
   "camber": -0.011
  },
  {
   "x": -69.71,
   "z": 484.59,
   "y": 122.24,
   "width": 6.2,
   "camber": -0.011
  },
  {
   "x": -68.26,
   "z": 496.49,
   "y": 122.36,
   "width": 6.2,
   "camber": -0.01
  },
  {
   "x": -65.89,
   "z": 508.26,
   "y": 122.48,
   "width": 6.2,
   "camber": -0.008
  },
  {
   "x": -62.79,
   "z": 519.85,
   "y": 122.61,
   "width": 6.2,
   "camber": -0.005
  },
  {
   "x": -59.26,
   "z": 531.31,
   "y": 122.76,
   "width": 6.2,
   "camber": -0.002
  },
  {
   "x": -55.56,
   "z": 542.73,
   "y": 122.94,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -51.85,
   "z": 554.14,
   "y": 123.14,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -48.14,
   "z": 565.56,
   "y": 123.37,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -44.43,
   "z": 576.97,
   "y": 123.6,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -40.72,
   "z": 588.38,
   "y": 123.84,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -37.02,
   "z": 599.79,
   "y": 124.08,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -33.31,
   "z": 611.21,
   "y": 124.32,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -29.6,
   "z": 622.62,
   "y": 124.56,
   "width": 6.2,
   "camber": 0.001
  },
  {
   "x": -25.97,
   "z": 634.06,
   "y": 124.8,
   "width": 6.2,
   "camber": 0.008
  },
  {
   "x": -23,
   "z": 645.68,
   "y": 125.04,
   "width": 6.2,
   "camber": 0.016
  },
  {
   "x": -21.42,
   "z": 657.56,
   "y": 125.28,
   "width": 6.2,
   "camber": 0.02
  },
  {
   "x": -21.62,
   "z": 669.55,
   "y": 125.52,
   "width": 6.2,
   "camber": 0.02
  },
  {
   "x": -23.62,
   "z": 681.37,
   "y": 125.76,
   "width": 6.2,
   "camber": 0.02
  },
  {
   "x": -27.36,
   "z": 692.76,
   "y": 126,
   "width": 6.2,
   "camber": 0.018
  },
  {
   "x": -32.62,
   "z": 703.54,
   "y": 126.21,
   "width": 6.2,
   "camber": 0.011
  },
  {
   "x": -38.75,
   "z": 713.85,
   "y": 126.37,
   "width": 6.2,
   "camber": 0.003
  },
  {
   "x": -45.11,
   "z": 724.03,
   "y": 126.48,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -51.47,
   "z": 734.21,
   "y": 126.54,
   "width": 6.2,
   "camber": -0.001
  },
  {
   "x": -57.79,
   "z": 744.41,
   "y": 126.55,
   "width": 6.2,
   "camber": -0.007
  },
  {
   "x": -63.56,
   "z": 754.92,
   "y": 126.55,
   "width": 6.2,
   "camber": -0.018
  },
  {
   "x": -67.88,
   "z": 766.1,
   "y": 126.55,
   "width": 6.2,
   "camber": -0.023
  },
  {
   "x": -70.23,
   "z": 777.86,
   "y": 126.55,
   "width": 6.2,
   "camber": -0.023
  },
  {
   "x": -70.56,
   "z": 789.84,
   "y": 126.55,
   "width": 6.2,
   "camber": -0.018
  },
  {
   "x": -69.22,
   "z": 801.76,
   "y": 126.55,
   "width": 6.2,
   "camber": -0.008
  },
  {
   "x": -67.2,
   "z": 813.59,
   "y": 126.55,
   "width": 6.2,
   "camber": -0.001
  },
  {
   "x": -65.11,
   "z": 825.4,
   "y": 126.55,
   "width": 6.2,
   "camber": 0.003
  },
  {
   "x": -63.23,
   "z": 837.25,
   "y": 126.55,
   "width": 6.2,
   "camber": 0.021
  },
  {
   "x": -63.22,
   "z": 849.22,
   "y": 126.55,
   "width": 6.2,
   "camber": 0.034
  },
  {
   "x": -66.32,
   "z": 860.78,
   "y": 126.56,
   "width": 6.2,
   "camber": 0.036
  },
  {
   "x": -72.35,
   "z": 871.11,
   "y": 126.6,
   "width": 6.2,
   "camber": 0.031
  },
  {
   "x": -80.71,
   "z": 879.69,
   "y": 126.71,
   "width": 6.2,
   "camber": 0.013
  },
  {
   "x": -89.88,
   "z": 887.43,
   "y": 126.89,
   "width": 6.2,
   "camber": 0.001
  },
  {
   "x": -99.07,
   "z": 895.14,
   "y": 127.14,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -108.27,
   "z": 902.86,
   "y": 127.47,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -117.46,
   "z": 910.57,
   "y": 127.83,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -126.65,
   "z": 918.29,
   "y": 128.19,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -129.71,
   "z": 920.86,
   "y": 128.43,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -132.78,
   "z": 923.43,
   "y": 128.96,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -136.99,
   "z": 926.96,
   "y": 129.92,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -140.06,
   "z": 929.54,
   "y": 130.57,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -143.12,
   "z": 932.11,
   "y": 130.99,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -146.18,
   "z": 934.68,
   "y": 131.11,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -149.25,
   "z": 937.25,
   "y": 130.93,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -152.31,
   "z": 939.82,
   "y": 130.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -155.38,
   "z": 942.39,
   "y": 130.05,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -158.44,
   "z": 944.96,
   "y": 129.68,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -161.5,
   "z": 947.53,
   "y": 129.57,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -170.7,
   "z": 955.25,
   "y": 129.88,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -179.89,
   "z": 962.96,
   "y": 130.13,
   "width": 6.2,
   "camber": -0.001
  },
  {
   "x": -189.06,
   "z": 970.7,
   "y": 130.31,
   "width": 6.2,
   "camber": -0.01
  },
  {
   "x": -197.65,
   "z": 979.06,
   "y": 130.42,
   "width": 6.2,
   "camber": -0.025
  },
  {
   "x": -204.46,
   "z": 988.91,
   "y": 130.45,
   "width": 6.2,
   "camber": -0.035
  },
  {
   "x": -208.48,
   "z": 1000.17,
   "y": 130.45,
   "width": 6.2,
   "camber": -0.042
  },
  {
   "x": -208.85,
   "z": 1012.11,
   "y": 130.47,
   "width": 6.2,
   "camber": -0.048
  },
  {
   "x": -204.98,
   "z": 1023.39,
   "y": 130.54,
   "width": 6.2,
   "camber": -0.032
  },
  {
   "x": -198.3,
   "z": 1033.36,
   "y": 130.65,
   "width": 6.2,
   "camber": -0.004
  },
  {
   "x": -191.42,
   "z": 1043.19,
   "y": 130.81,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -184.54,
   "z": 1053.02,
   "y": 131.02,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -177.66,
   "z": 1062.85,
   "y": 131.25,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -170.77,
   "z": 1072.68,
   "y": 131.49,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -163.89,
   "z": 1082.51,
   "y": 131.73,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -157.01,
   "z": 1092.34,
   "y": 131.97,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -150.12,
   "z": 1102.17,
   "y": 132.21,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -143.24,
   "z": 1112,
   "y": 132.42,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -136.36,
   "z": 1121.83,
   "y": 132.61,
   "width": 6.2,
   "camber": 0.001
  },
  {
   "x": -129.54,
   "z": 1131.7,
   "y": 132.77,
   "width": 6.2,
   "camber": 0.004
  },
  {
   "x": -123.02,
   "z": 1141.78,
   "y": 132.91,
   "width": 6.2,
   "camber": 0.007
  },
  {
   "x": -117.08,
   "z": 1152.2,
   "y": 133.03,
   "width": 6.2,
   "camber": 0.01
  },
  {
   "x": -111.98,
   "z": 1163.06,
   "y": 133.15,
   "width": 6.2,
   "camber": 0.011
  },
  {
   "x": -107.82,
   "z": 1174.31,
   "y": 133.28,
   "width": 6.2,
   "camber": 0.011
  },
  {
   "x": -104.64,
   "z": 1185.88,
   "y": 133.4,
   "width": 6.2,
   "camber": 0.011
  },
  {
   "x": -102.47,
   "z": 1197.68,
   "y": 133.52,
   "width": 6.2,
   "camber": 0.011
  },
  {
   "x": -101.31,
   "z": 1209.62,
   "y": 133.64,
   "width": 6.2,
   "camber": 0.011
  },
  {
   "x": -101.18,
   "z": 1221.61,
   "y": 133.76,
   "width": 6.2,
   "camber": 0.011
  },
  {
   "x": -102.08,
   "z": 1233.57,
   "y": 133.88,
   "width": 6.2,
   "camber": 0.011
  },
  {
   "x": -104,
   "z": 1245.42,
   "y": 134,
   "width": 6.2,
   "camber": 0.011
  },
  {
   "x": -106.92,
   "z": 1257.05,
   "y": 134.12,
   "width": 6.2,
   "camber": 0.011
  },
  {
   "x": -110.83,
   "z": 1268.39,
   "y": 134.24,
   "width": 6.2,
   "camber": 0.011
  },
  {
   "x": -115.7,
   "z": 1279.36,
   "y": 134.36,
   "width": 6.2,
   "camber": 0.011
  },
  {
   "x": -121.48,
   "z": 1289.87,
   "y": 134.48,
   "width": 6.2,
   "camber": 0.01
  },
  {
   "x": -128,
   "z": 1299.94,
   "y": 134.6,
   "width": 6.2,
   "camber": 0.006
  },
  {
   "x": -135,
   "z": 1309.69,
   "y": 134.75,
   "width": 6.2,
   "camber": 0.003
  },
  {
   "x": -142.19,
   "z": 1319.29,
   "y": 134.92,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -149.42,
   "z": 1328.87,
   "y": 135.12,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -156.64,
   "z": 1338.46,
   "y": 135.34,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -163.86,
   "z": 1348.04,
   "y": 135.58,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -171.08,
   "z": 1357.62,
   "y": 135.82,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -178.3,
   "z": 1367.21,
   "y": 136.06,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -183.12,
   "z": 1373.6,
   "y": 136.22,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -185.52,
   "z": 1376.79,
   "y": 135.93,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -187.93,
   "z": 1379.99,
   "y": 135.22,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -190.34,
   "z": 1383.18,
   "y": 134.78,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -192.75,
   "z": 1386.38,
   "y": 135.05,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -195.15,
   "z": 1389.57,
   "y": 135.87,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -197.56,
   "z": 1392.77,
   "y": 136.6,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -204.78,
   "z": 1402.35,
   "y": 136.94,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -212,
   "z": 1411.93,
   "y": 137.18,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -219.22,
   "z": 1421.52,
   "y": 137.42,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -226.45,
   "z": 1431.1,
   "y": 137.69,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -233.67,
   "z": 1440.68,
   "y": 138.04,
   "width": 6.2,
   "camber": -0.002
  },
  {
   "x": -240.81,
   "z": 1450.33,
   "y": 138.46,
   "width": 6.2,
   "camber": -0.026
  },
  {
   "x": -245.77,
   "z": 1460.64,
   "y": 138.93,
   "width": 6.2,
   "camber": -0.048
  },
  {
   "x": -246.84,
   "z": 1472.03,
   "y": 139.52,
   "width": 6.2,
   "camber": -0.046
  },
  {
   "x": -243.81,
   "z": 1483.59,
   "y": 140.24,
   "width": 6.2,
   "camber": -0.02
  },
  {
   "x": -239.14,
   "z": 1494.65,
   "y": 141.03,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -234.45,
   "z": 1505.69,
   "y": 141.89,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -229.76,
   "z": 1516.74,
   "y": 142.83,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -225.08,
   "z": 1527.78,
   "y": 143.78,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -220.39,
   "z": 1538.83,
   "y": 144.7,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -215.7,
   "z": 1549.88,
   "y": 145.57,
   "width": 6.2,
   "camber": 0.037
  },
  {
   "x": -213.5,
   "z": 1555.46,
   "y": 145.99,
   "width": 6.6,
   "camber": 0.06
  },
  {
   "x": -213.01,
   "z": 1559.41,
   "y": 146.26,
   "width": 6.6,
   "camber": 0.06
  },
  {
   "x": -213.94,
   "z": 1563.28,
   "y": 146.53,
   "width": 6.6,
   "camber": 0.06
  },
  {
   "x": -216.18,
   "z": 1566.56,
   "y": 146.8,
   "width": 6.6,
   "camber": 0.06
  },
  {
   "x": -219.44,
   "z": 1568.84,
   "y": 147.07,
   "width": 6.6,
   "camber": 0.06
  },
  {
   "x": -223.3,
   "z": 1569.8,
   "y": 147.33,
   "width": 6.6,
   "camber": 0.06
  },
  {
   "x": -227.25,
   "z": 1569.33,
   "y": 147.6,
   "width": 6.6,
   "camber": 0.06
  },
  {
   "x": -230.78,
   "z": 1567.49,
   "y": 147.87,
   "width": 6.6,
   "camber": 0.06
  },
  {
   "x": -237.64,
   "z": 1557.72,
   "y": 148.7,
   "width": 6.2,
   "camber": 0.016
  },
  {
   "x": -243.82,
   "z": 1547.44,
   "y": 149.59,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -250.01,
   "z": 1537.15,
   "y": 150.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -256.19,
   "z": 1526.87,
   "y": 151.48,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -262.37,
   "z": 1516.58,
   "y": 152.43,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -268.55,
   "z": 1506.29,
   "y": 153.36,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -274.73,
   "z": 1496.01,
   "y": 154.24,
   "width": 6.2,
   "camber": -0.024
  },
  {
   "x": -278.71,
   "z": 1489.66,
   "y": 154.76,
   "width": 6.6,
   "camber": -0.06
  },
  {
   "x": -281.97,
   "z": 1486.59,
   "y": 155.07,
   "width": 6.6,
   "camber": -0.06
  },
  {
   "x": -286.12,
   "z": 1484.92,
   "y": 155.37,
   "width": 6.6,
   "camber": -0.06
  },
  {
   "x": -290.59,
   "z": 1484.88,
   "y": 155.66,
   "width": 6.6,
   "camber": -0.06
  },
  {
   "x": -294.77,
   "z": 1486.48,
   "y": 155.95,
   "width": 6.6,
   "camber": -0.06
  },
  {
   "x": -298.07,
   "z": 1489.5,
   "y": 156.24,
   "width": 6.6,
   "camber": -0.06
  },
  {
   "x": -300.04,
   "z": 1493.52,
   "y": 156.53,
   "width": 6.6,
   "camber": -0.06
  },
  {
   "x": -300.39,
   "z": 1497.98,
   "y": 156.81,
   "width": 6.6,
   "camber": -0.06
  },
  {
   "x": -296.9,
   "z": 1509.43,
   "y": 157.59,
   "width": 6.2,
   "camber": -0.008
  },
  {
   "x": -292.99,
   "z": 1520.78,
   "y": 158.4,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -289.08,
   "z": 1532.13,
   "y": 159.23,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -285.18,
   "z": 1543.47,
   "y": 160.07,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -281.27,
   "z": 1554.82,
   "y": 160.91,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -277.36,
   "z": 1566.16,
   "y": 161.74,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -273.45,
   "z": 1577.51,
   "y": 162.5,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -269.55,
   "z": 1588.86,
   "y": 163.2,
   "width": 6.2,
   "camber": 0.007
  },
  {
   "x": -266.09,
   "z": 1600.34,
   "y": 163.82,
   "width": 6.2,
   "camber": 0.027
  },
  {
   "x": -265.16,
   "z": 1612.26,
   "y": 164.38,
   "width": 6.2,
   "camber": 0.038
  },
  {
   "x": -267.62,
   "z": 1623.97,
   "y": 164.85,
   "width": 6.2,
   "camber": 0.034
  },
  {
   "x": -273.07,
   "z": 1634.64,
   "y": 165.29,
   "width": 6.2,
   "camber": 0.014
  },
  {
   "x": -279.58,
   "z": 1644.72,
   "y": 165.71,
   "width": 6.2,
   "camber": 0.001
  },
  {
   "x": -286.11,
   "z": 1654.78,
   "y": 166.1,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -292.65,
   "z": 1664.85,
   "y": 166.48,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -299.18,
   "z": 1674.91,
   "y": 166.84,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -305.72,
   "z": 1684.97,
   "y": 167.2,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -312.25,
   "z": 1695.04,
   "y": 167.56,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -318.79,
   "z": 1705.1,
   "y": 167.9,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -325.32,
   "z": 1715.17,
   "y": 168.2,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -331.86,
   "z": 1725.23,
   "y": 168.45,
   "width": 6.2,
   "camber": -0.001
  },
  {
   "x": -338.32,
   "z": 1735.34,
   "y": 168.66,
   "width": 6.2,
   "camber": -0.004
  },
  {
   "x": -344.52,
   "z": 1745.62,
   "y": 168.81,
   "width": 6.2,
   "camber": -0.006
  },
  {
   "x": -350.22,
   "z": 1756.17,
   "y": 168.94,
   "width": 6.2,
   "camber": -0.009
  },
  {
   "x": -355.21,
   "z": 1767.09,
   "y": 169.06,
   "width": 6.2,
   "camber": -0.009
  },
  {
   "x": -359.41,
   "z": 1778.32,
   "y": 169.18,
   "width": 6.2,
   "camber": -0.009
  },
  {
   "x": -362.82,
   "z": 1789.83,
   "y": 169.3,
   "width": 6.2,
   "camber": -0.009
  },
  {
   "x": -365.4,
   "z": 1801.54,
   "y": 169.42,
   "width": 6.2,
   "camber": -0.009
  },
  {
   "x": -367.18,
   "z": 1813.41,
   "y": 169.54,
   "width": 6.2,
   "camber": -0.007
  },
  {
   "x": -368.32,
   "z": 1825.35,
   "y": 169.64,
   "width": 6.2,
   "camber": -0.004
  },
  {
   "x": -369.09,
   "z": 1837.33,
   "y": 169.73,
   "width": 6.2,
   "camber": -0.002
  },
  {
   "x": -369.72,
   "z": 1849.31,
   "y": 169.79,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -370.35,
   "z": 1861.29,
   "y": 169.83,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -370.98,
   "z": 1873.28,
   "y": 169.84,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -371.6,
   "z": 1885.26,
   "y": 169.84,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -372.15,
   "z": 1895.75,
   "y": 169.84,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -372.36,
   "z": 1899.74,
   "y": 170.01,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -372.57,
   "z": 1903.74,
   "y": 170.45,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -372.78,
   "z": 1907.73,
   "y": 170.95,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -372.99,
   "z": 1911.73,
   "y": 171.29,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -373.2,
   "z": 1915.72,
   "y": 171.22,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -373.41,
   "z": 1919.71,
   "y": 170.38,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -373.62,
   "z": 1923.71,
   "y": 169.84,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -374.24,
   "z": 1935.69,
   "y": 169.84,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -374.87,
   "z": 1947.68,
   "y": 169.84,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -375.5,
   "z": 1959.66,
   "y": 169.84,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -376.13,
   "z": 1971.64,
   "y": 169.84,
   "width": 6.2,
   "camber": 0.001
  },
  {
   "x": -376.5,
   "z": 1978.63,
   "y": 169.84,
   "width": 6.2,
   "camber": 0.003
  },
  {
   "x": -376.74,
   "z": 1982.63,
   "y": 169.97,
   "width": 6.2,
   "camber": 0.005
  },
  {
   "x": -377.04,
   "z": 1986.61,
   "y": 170.32,
   "width": 6.2,
   "camber": 0.007
  },
  {
   "x": -377.41,
   "z": 1990.6,
   "y": 170.76,
   "width": 6.2,
   "camber": 0.01
  },
  {
   "x": -377.87,
   "z": 1994.57,
   "y": 171.11,
   "width": 6.2,
   "camber": 0.012
  },
  {
   "x": -378.45,
   "z": 1998.53,
   "y": 171.24,
   "width": 6.2,
   "camber": 0.014
  },
  {
   "x": -379.17,
   "z": 2002.46,
   "y": 171.11,
   "width": 6.2,
   "camber": 0.016
  },
  {
   "x": -380.05,
   "z": 2006.36,
   "y": 170.76,
   "width": 6.2,
   "camber": 0.017
  },
  {
   "x": -381.11,
   "z": 2010.22,
   "y": 170.32,
   "width": 6.2,
   "camber": 0.017
  },
  {
   "x": -382.33,
   "z": 2014.03,
   "y": 169.97,
   "width": 6.2,
   "camber": 0.018
  },
  {
   "x": -383.72,
   "z": 2017.78,
   "y": 169.84,
   "width": 6.2,
   "camber": 0.018
  },
  {
   "x": -388.87,
   "z": 2028.61,
   "y": 169.84,
   "width": 6.2,
   "camber": 0.018
  },
  {
   "x": -395.4,
   "z": 2038.67,
   "y": 169.84,
   "width": 6.2,
   "camber": 0.014
  },
  {
   "x": -402.97,
   "z": 2047.98,
   "y": 169.82,
   "width": 6.2,
   "camber": 0.008
  },
  {
   "x": -411.05,
   "z": 2056.85,
   "y": 169.77,
   "width": 6.2,
   "camber": 0.002
  },
  {
   "x": -419.23,
   "z": 2065.62,
   "y": 169.7,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -427.42,
   "z": 2074.4,
   "y": 169.61,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -435.6,
   "z": 2083.18,
   "y": 169.5,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -443.78,
   "z": 2091.95,
   "y": 169.38,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -451.97,
   "z": 2100.73,
   "y": 169.26,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -458.45,
   "z": 2107.68,
   "y": 169.16,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -461.17,
   "z": 2110.6,
   "y": 169.34,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -463.9,
   "z": 2113.53,
   "y": 169.89,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -466.63,
   "z": 2116.45,
   "y": 170.59,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -469.36,
   "z": 2119.38,
   "y": 171.19,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -472.09,
   "z": 2122.3,
   "y": 171.45,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -474.81,
   "z": 2125.23,
   "y": 170.95,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -477.54,
   "z": 2128.16,
   "y": 169.59,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -480.27,
   "z": 2131.08,
   "y": 168.84,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -488.45,
   "z": 2139.86,
   "y": 168.72,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -496.64,
   "z": 2148.63,
   "y": 168.6,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -504.82,
   "z": 2157.41,
   "y": 168.46,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -513,
   "z": 2166.19,
   "y": 168.29,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -521.18,
   "z": 2174.97,
   "y": 168.11,
   "width": 6.2,
   "camber": -0.001
  },
  {
   "x": -529.27,
   "z": 2183.84,
   "y": 167.89,
   "width": 6.2,
   "camber": -0.003
  },
  {
   "x": -537.17,
   "z": 2192.86,
   "y": 167.66,
   "width": 6.2,
   "camber": -0.004
  },
  {
   "x": -544.79,
   "z": 2202.13,
   "y": 167.42,
   "width": 6.2,
   "camber": -0.005
  },
  {
   "x": -552.06,
   "z": 2211.68,
   "y": 167.18,
   "width": 6.2,
   "camber": -0.005
  },
  {
   "x": -558.96,
   "z": 2221.5,
   "y": 166.94,
   "width": 6.2,
   "camber": -0.005
  },
  {
   "x": -565.49,
   "z": 2231.56,
   "y": 166.7,
   "width": 6.2,
   "camber": -0.005
  },
  {
   "x": -571.64,
   "z": 2241.87,
   "y": 166.46,
   "width": 6.2,
   "camber": -0.004
  },
  {
   "x": -577.45,
   "z": 2252.37,
   "y": 166.22,
   "width": 6.2,
   "camber": -0.003
  },
  {
   "x": -583.03,
   "z": 2262.99,
   "y": 165.95,
   "width": 6.2,
   "camber": -0.001
  },
  {
   "x": -588.49,
   "z": 2273.68,
   "y": 165.66,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -593.94,
   "z": 2284.37,
   "y": 165.35,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -599.39,
   "z": 2295.06,
   "y": 165.01,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -604.83,
   "z": 2305.75,
   "y": 164.66,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -610.28,
   "z": 2316.45,
   "y": 164.3,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -615.73,
   "z": 2327.14,
   "y": 163.94,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -621.18,
   "z": 2337.83,
   "y": 163.58,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -626.62,
   "z": 2348.52,
   "y": 163.22,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -629.12,
   "z": 2353.42,
   "y": 163.05,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -630.94,
   "z": 2356.99,
   "y": 163.05,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -632.75,
   "z": 2360.55,
   "y": 163.26,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -635.25,
   "z": 2365.45,
   "y": 163.69,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -637.06,
   "z": 2369.02,
   "y": 163.94,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -638.88,
   "z": 2372.58,
   "y": 164,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -640.7,
   "z": 2376.14,
   "y": 163.82,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -642.51,
   "z": 2379.71,
   "y": 163.41,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -645.46,
   "z": 2385.5,
   "y": 162.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -647.28,
   "z": 2389.06,
   "y": 162.04,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -649.09,
   "z": 2392.63,
   "y": 161.74,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -654.54,
   "z": 2403.32,
   "y": 161.37,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -659.99,
   "z": 2414.01,
   "y": 161.01,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -665.44,
   "z": 2424.71,
   "y": 160.65,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -670.88,
   "z": 2435.4,
   "y": 160.29,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -676.33,
   "z": 2446.09,
   "y": 159.93,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -681.78,
   "z": 2456.78,
   "y": 159.57,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -687.22,
   "z": 2467.48,
   "y": 159.21,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -690.4,
   "z": 2473.71,
   "y": 159,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -692.22,
   "z": 2477.28,
   "y": 159.06,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -694.72,
   "z": 2482.18,
   "y": 159.55,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -696.53,
   "z": 2485.74,
   "y": 159.86,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -698.35,
   "z": 2489.31,
   "y": 159.86,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -700.39,
   "z": 2493.31,
   "y": 158.91,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -702.21,
   "z": 2496.88,
   "y": 158.22,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -707.65,
   "z": 2507.57,
   "y": 157.86,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -713.1,
   "z": 2518.26,
   "y": 157.5,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -718.55,
   "z": 2528.96,
   "y": 157.14,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -723.99,
   "z": 2539.65,
   "y": 156.78,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -729.44,
   "z": 2550.34,
   "y": 156.42,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -733.53,
   "z": 2558.36,
   "y": 156.15,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -735.34,
   "z": 2561.92,
   "y": 155.71,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -737.16,
   "z": 2565.49,
   "y": 154.94,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -738.98,
   "z": 2569.05,
   "y": 154.49,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -740.79,
   "z": 2572.62,
   "y": 154.7,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -742.61,
   "z": 2576.18,
   "y": 155.23,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -744.42,
   "z": 2579.74,
   "y": 155.43,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -749.87,
   "z": 2590.44,
   "y": 155.07,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -755.32,
   "z": 2601.13,
   "y": 154.71,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -760.76,
   "z": 2611.82,
   "y": 154.35,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -766.21,
   "z": 2622.51,
   "y": 153.99,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -771.66,
   "z": 2633.21,
   "y": 153.63,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -777.11,
   "z": 2643.9,
   "y": 153.27,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -778.92,
   "z": 2647.46,
   "y": 153.15,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -780.74,
   "z": 2651.03,
   "y": 153.14,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -782.55,
   "z": 2654.59,
   "y": 153.33,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -785.73,
   "z": 2660.83,
   "y": 153.88,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -787.55,
   "z": 2664.39,
   "y": 154.14,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -789.36,
   "z": 2667.96,
   "y": 154.23,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -791.18,
   "z": 2671.52,
   "y": 154.11,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -793,
   "z": 2675.08,
   "y": 153.78,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -794.81,
   "z": 2678.65,
   "y": 153.28,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -797.08,
   "z": 2683.1,
   "y": 152.57,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -798.9,
   "z": 2686.67,
   "y": 152.07,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -800.71,
   "z": 2690.23,
   "y": 151.74,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -806.16,
   "z": 2700.92,
   "y": 151.35,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -811.61,
   "z": 2711.62,
   "y": 150.99,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -817.05,
   "z": 2722.31,
   "y": 150.63,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -819.1,
   "z": 2726.32,
   "y": 150.81,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -820.91,
   "z": 2729.88,
   "y": 150.8,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -822.73,
   "z": 2733.45,
   "y": 150.26,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -828.18,
   "z": 2744.14,
   "y": 149.9,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -833.62,
   "z": 2754.83,
   "y": 149.55,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -839.07,
   "z": 2765.52,
   "y": 149.26,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -844.52,
   "z": 2776.22,
   "y": 149.01,
   "width": 6.4,
   "camber": 0
  },
  {
   "x": -849.97,
   "z": 2786.91,
   "y": 148.82,
   "width": 6.4,
   "camber": 0
  },
  {
   "x": -855.41,
   "z": 2797.6,
   "y": 148.69,
   "width": 6.4,
   "camber": 0
  },
  {
   "x": -860.86,
   "z": 2808.29,
   "y": 148.62,
   "width": 6.8,
   "camber": 0.047
  },
  {
   "x": -863.43,
   "z": 2812.57,
   "y": 148.6,
   "width": 6.8,
   "camber": 0.06
  },
  {
   "x": -867.19,
   "z": 2815.83,
   "y": 148.58,
   "width": 6.8,
   "camber": 0.06
  },
  {
   "x": -871.89,
   "z": 2817.44,
   "y": 148.57,
   "width": 6.8,
   "camber": 0.06
  },
  {
   "x": -876.85,
   "z": 2817.17,
   "y": 148.56,
   "width": 6.8,
   "camber": 0.06
  },
  {
   "x": -887.72,
   "z": 2812.13,
   "y": 148.55,
   "width": 6,
   "camber": 0.009
  },
  {
   "x": -898.41,
   "z": 2806.68,
   "y": 148.55,
   "width": 6,
   "camber": 0
  },
  {
   "x": -909.1,
   "z": 2801.23,
   "y": 148.55,
   "width": 6,
   "camber": 0
  },
  {
   "x": -919.79,
   "z": 2795.79,
   "y": 148.55,
   "width": 6,
   "camber": 0
  },
  {
   "x": -930.48,
   "z": 2790.34,
   "y": 148.55,
   "width": 6,
   "camber": 0
  },
  {
   "x": -941.18,
   "z": 2784.89,
   "y": 148.55,
   "width": 6,
   "camber": 0
  },
  {
   "x": -951.87,
   "z": 2779.45,
   "y": 148.55,
   "width": 6,
   "camber": 0
  },
  {
   "x": -962.56,
   "z": 2774,
   "y": 148.55,
   "width": 6,
   "camber": 0
  },
  {
   "x": -973.25,
   "z": 2768.55,
   "y": 148.55,
   "width": 6,
   "camber": 0
  },
  {
   "x": -983.95,
   "z": 2763.1,
   "y": 148.55,
   "width": 6,
   "camber": -0.009
  },
  {
   "x": -992.45,
   "z": 2758.87,
   "y": 148.55,
   "width": 6.8,
   "camber": -0.06
  },
  {
   "x": -997.29,
   "z": 2757.72,
   "y": 148.54,
   "width": 6.8,
   "camber": -0.06
  },
  {
   "x": -1002.21,
   "z": 2758.43,
   "y": 148.53,
   "width": 6.8,
   "camber": -0.06
  },
  {
   "x": -1006.5,
   "z": 2760.94,
   "y": 148.51,
   "width": 6.8,
   "camber": -0.06
  },
  {
   "x": -1012.81,
   "z": 2771.05,
   "y": 148.45,
   "width": 6,
   "camber": -0.019
  },
  {
   "x": -1018.26,
   "z": 2781.75,
   "y": 148.37,
   "width": 6,
   "camber": 0
  },
  {
   "x": -1023.7,
   "z": 2792.44,
   "y": 148.27,
   "width": 6,
   "camber": 0
  },
  {
   "x": -1029.15,
   "z": 2803.13,
   "y": 148.15,
   "width": 6,
   "camber": 0
  },
  {
   "x": -1034.6,
   "z": 2813.82,
   "y": 148.03,
   "width": 6,
   "camber": 0
  },
  {
   "x": -1040.05,
   "z": 2824.52,
   "y": 147.93,
   "width": 6,
   "camber": 0
  },
  {
   "x": -1045.49,
   "z": 2835.21,
   "y": 147.85,
   "width": 6,
   "camber": 0.001
  },
  {
   "x": -1050.98,
   "z": 2845.88,
   "y": 147.79,
   "width": 6.2,
   "camber": 0.007
  },
  {
   "x": -1056.98,
   "z": 2856.27,
   "y": 147.76,
   "width": 6.2,
   "camber": 0.016
  },
  {
   "x": -1064.19,
   "z": 2865.85,
   "y": 147.75,
   "width": 6.2,
   "camber": 0.021
  },
  {
   "x": -1072.81,
   "z": 2874.18,
   "y": 147.75,
   "width": 6.2,
   "camber": 0.021
  },
  {
   "x": -1082.65,
   "z": 2881.02,
   "y": 147.75,
   "width": 6.2,
   "camber": 0.02
  },
  {
   "x": -1093.43,
   "z": 2886.27,
   "y": 147.72,
   "width": 6.2,
   "camber": 0.014
  },
  {
   "x": -1104.7,
   "z": 2890.38,
   "y": 147.65,
   "width": 6.2,
   "camber": 0.005
  },
  {
   "x": -1116.11,
   "z": 2894.1,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1127.52,
   "z": 2897.8,
   "y": 147.33,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1138.94,
   "z": 2901.51,
   "y": 147.06,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1150.35,
   "z": 2905.22,
   "y": 146.75,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1161.76,
   "z": 2908.93,
   "y": 146.41,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1168.89,
   "z": 2911.25,
   "y": 146.19,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1172.7,
   "z": 2912.49,
   "y": 145.98,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1178.4,
   "z": 2914.34,
   "y": 145.48,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1182.21,
   "z": 2915.58,
   "y": 145.19,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1186.01,
   "z": 2916.81,
   "y": 145.07,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1189.82,
   "z": 2918.05,
   "y": 145.12,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1193.62,
   "z": 2919.29,
   "y": 145.22,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1197.42,
   "z": 2920.52,
   "y": 145.27,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1208.84,
   "z": 2924.23,
   "y": 145,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1220.25,
   "z": 2927.94,
   "y": 144.8,
   "width": 6.2,
   "camber": -0.002
  },
  {
   "x": -1231.62,
   "z": 2931.76,
   "y": 144.69,
   "width": 6.2,
   "camber": -0.018
  },
  {
   "x": -1242.36,
   "z": 2937.07,
   "y": 144.68,
   "width": 6.2,
   "camber": -0.034
  },
  {
   "x": -1251.37,
   "z": 2944.93,
   "y": 144.77,
   "width": 6.2,
   "camber": -0.036
  },
  {
   "x": -1258,
   "z": 2954.89,
   "y": 144.89,
   "width": 6.2,
   "camber": -0.036
  },
  {
   "x": -1261.77,
   "z": 2966.25,
   "y": 144.99,
   "width": 6.2,
   "camber": -0.029
  },
  {
   "x": -1262.93,
   "z": 2978.18,
   "y": 145.07,
   "width": 6.2,
   "camber": -0.009
  },
  {
   "x": -1263.36,
   "z": 2990.17,
   "y": 145.12,
   "width": 5.2,
   "camber": 0
  },
  {
   "x": -1263.78,
   "z": 3002.17,
   "y": 145.15,
   "width": 5.2,
   "camber": 0
  },
  {
   "x": -1264.19,
   "z": 3014.16,
   "y": 145.16,
   "width": 5.2,
   "camber": 0
  },
  {
   "x": -1264.61,
   "z": 3026.15,
   "y": 145.16,
   "width": 5.2,
   "camber": 0
  },
  {
   "x": -1265.03,
   "z": 3038.14,
   "y": 145.16,
   "width": 5.2,
   "camber": 0
  },
  {
   "x": -1265.45,
   "z": 3050.14,
   "y": 145.16,
   "width": 4.2,
   "camber": 0
  },
  {
   "x": -1265.87,
   "z": 3062.13,
   "y": 145.19,
   "width": 4.2,
   "camber": 0
  },
  {
   "x": -1266.28,
   "z": 3074.12,
   "y": 145.25,
   "width": 5.2,
   "camber": 0
  },
  {
   "x": -1266.7,
   "z": 3086.11,
   "y": 145.36,
   "width": 5.2,
   "camber": 0
  },
  {
   "x": -1267.13,
   "z": 3098.11,
   "y": 145.51,
   "width": 6.2,
   "camber": 0.004
  },
  {
   "x": -1267.86,
   "z": 3110.08,
   "y": 145.71,
   "width": 6.2,
   "camber": 0.011
  },
  {
   "x": -1269.56,
   "z": 3121.96,
   "y": 145.94,
   "width": 6.2,
   "camber": 0.017
  },
  {
   "x": -1272.77,
   "z": 3133.51,
   "y": 146.18,
   "width": 6.2,
   "camber": 0.019
  },
  {
   "x": -1277.58,
   "z": 3144.49,
   "y": 146.42,
   "width": 6.2,
   "camber": 0.019
  },
  {
   "x": -1283.89,
   "z": 3154.69,
   "y": 146.66,
   "width": 6.2,
   "camber": 0.019
  },
  {
   "x": -1291.57,
   "z": 3163.9,
   "y": 146.9,
   "width": 6.2,
   "camber": 0.016
  },
  {
   "x": -1300.33,
   "z": 3172.09,
   "y": 147.14,
   "width": 6.2,
   "camber": 0.009
  },
  {
   "x": -1309.65,
   "z": 3179.65,
   "y": 147.38,
   "width": 6.2,
   "camber": 0.003
  },
  {
   "x": -1319.1,
   "z": 3187.04,
   "y": 147.62,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1328.56,
   "z": 3194.43,
   "y": 147.86,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1338.01,
   "z": 3201.82,
   "y": 148.1,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1347.47,
   "z": 3209.21,
   "y": 148.34,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1356.93,
   "z": 3216.59,
   "y": 148.56,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1366.38,
   "z": 3223.98,
   "y": 148.75,
   "width": 6.2,
   "camber": 0.003
  },
  {
   "x": -1375.94,
   "z": 3231.23,
   "y": 148.92,
   "width": 6.2,
   "camber": 0.014
  },
  {
   "x": -1386.2,
   "z": 3237.44,
   "y": 149.07,
   "width": 6.2,
   "camber": 0.024
  },
  {
   "x": -1397.41,
   "z": 3241.66,
   "y": 149.19,
   "width": 6.2,
   "camber": 0.024
  },
  {
   "x": -1409.2,
   "z": 3243.83,
   "y": 149.31,
   "width": 6.2,
   "camber": 0.021
  },
  {
   "x": -1421.19,
   "z": 3244.1,
   "y": 149.43,
   "width": 6.2,
   "camber": 0.019
  },
  {
   "x": -1433.1,
   "z": 3242.7,
   "y": 149.55,
   "width": 6.2,
   "camber": 0.016
  },
  {
   "x": -1444.75,
   "z": 3239.87,
   "y": 149.67,
   "width": 6.2,
   "camber": 0.013
  },
  {
   "x": -1456.06,
   "z": 3235.88,
   "y": 149.79,
   "width": 6.2,
   "camber": 0.01
  },
  {
   "x": -1467.05,
   "z": 3231.07,
   "y": 149.9,
   "width": 6.2,
   "camber": 0.006
  },
  {
   "x": -1477.83,
   "z": 3225.78,
   "y": 149.98,
   "width": 6.2,
   "camber": 0.002
  },
  {
   "x": -1488.52,
   "z": 3220.34,
   "y": 150.04,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1499.21,
   "z": 3214.89,
   "y": 150.07,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1509.91,
   "z": 3209.44,
   "y": 150.09,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1520.6,
   "z": 3203.99,
   "y": 150.09,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1531.29,
   "z": 3198.55,
   "y": 150.09,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1541.98,
   "z": 3193.1,
   "y": 150.08,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1552.68,
   "z": 3187.65,
   "y": 150.06,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1563.37,
   "z": 3182.21,
   "y": 150.01,
   "width": 6.2,
   "camber": -0.021
  },
  {
   "x": -1571.18,
   "z": 3178.9,
   "y": 149.96,
   "width": 6.2,
   "camber": -0.049
  },
  {
   "x": -1579.6,
   "z": 3178.1,
   "y": 149.9,
   "width": 6.2,
   "camber": -0.06
  },
  {
   "x": -1587.77,
   "z": 3180.28,
   "y": 149.82,
   "width": 6.2,
   "camber": -0.06
  },
  {
   "x": -1594.68,
   "z": 3185.15,
   "y": 149.71,
   "width": 6.2,
   "camber": -0.059
  },
  {
   "x": -1601.06,
   "z": 3195.23,
   "y": 149.55,
   "width": 6.2,
   "camber": -0.021
  },
  {
   "x": -1606.13,
   "z": 3206.11,
   "y": 149.36,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1611.21,
   "z": 3216.98,
   "y": 149.14,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1613.95,
   "z": 3222.87,
   "y": 149.02,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1615.64,
   "z": 3226.5,
   "y": 148.45,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1617.33,
   "z": 3230.12,
   "y": 148.09,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1619.02,
   "z": 3233.75,
   "y": 148.62,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1624.1,
   "z": 3244.63,
   "y": 148.54,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1629.17,
   "z": 3255.5,
   "y": 148.3,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1634.25,
   "z": 3266.37,
   "y": 148.05,
   "width": 6.2,
   "camber": 0.002
  },
  {
   "x": -1639.54,
   "z": 3277.14,
   "y": 147.81,
   "width": 6.2,
   "camber": 0.006
  },
  {
   "x": -1645.32,
   "z": 3287.66,
   "y": 147.57,
   "width": 6.2,
   "camber": 0.01
  },
  {
   "x": -1651.86,
   "z": 3297.72,
   "y": 147.33,
   "width": 6.2,
   "camber": 0.012
  },
  {
   "x": -1659.28,
   "z": 3307.14,
   "y": 147.09,
   "width": 6.2,
   "camber": 0.012
  },
  {
   "x": -1667.54,
   "z": 3315.84,
   "y": 146.85,
   "width": 6.2,
   "camber": 0.012
  },
  {
   "x": -1676.56,
   "z": 3323.74,
   "y": 146.61,
   "width": 6.2,
   "camber": 0.012
  },
  {
   "x": -1686.28,
   "z": 3330.78,
   "y": 146.37,
   "width": 6.2,
   "camber": 0.011
  },
  {
   "x": -1696.56,
   "z": 3336.95,
   "y": 146.14,
   "width": 6.2,
   "camber": 0.008
  },
  {
   "x": -1707.21,
   "z": 3342.48,
   "y": 145.91,
   "width": 6.2,
   "camber": 0.005
  },
  {
   "x": -1718.04,
   "z": 3347.64,
   "y": 145.72,
   "width": 6.2,
   "camber": 0.001
  },
  {
   "x": -1728.92,
   "z": 3352.72,
   "y": 145.54,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1739.8,
   "z": 3357.79,
   "y": 145.39,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1750.67,
   "z": 3362.86,
   "y": 145.27,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1761.55,
   "z": 3367.93,
   "y": 145.16,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1772.42,
   "z": 3373,
   "y": 145.09,
   "width": 6.2,
   "camber": -0.002
  },
  {
   "x": -1783.24,
   "z": 3378.2,
   "y": 145.03,
   "width": 6.2,
   "camber": 0.014
  },
  {
   "x": -1793.32,
   "z": 3384.67,
   "y": 145,
   "width": 6.2,
   "camber": -0.002
  },
  {
   "x": -1801.51,
   "z": 3393.39,
   "y": 144.99,
   "width": 6.2,
   "camber": -0.009
  },
  {
   "x": -1806.81,
   "z": 3404.1,
   "y": 144.99,
   "width": 6.2,
   "camber": -0.015
  },
  {
   "x": -1808.29,
   "z": 3415.45,
   "y": 145,
   "width": 6.2,
   "camber": -0.02
  },
  {
   "x": -1806.05,
   "z": 3425.66,
   "y": 145.02,
   "width": 6.2,
   "camber": -0.019
  },
  {
   "x": -1799.54,
   "z": 3435.68,
   "y": 145.06,
   "width": 6.2,
   "camber": 0.011
  },
  {
   "x": -1791.83,
   "z": 3444.87,
   "y": 145.13,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1784.12,
   "z": 3454.06,
   "y": 145.22,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1776.4,
   "z": 3463.26,
   "y": 145.33,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1768.69,
   "z": 3472.45,
   "y": 145.45,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1760.98,
   "z": 3481.64,
   "y": 145.57,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1757.12,
   "z": 3486.24,
   "y": 145.63,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1754.55,
   "z": 3489.31,
   "y": 145.85,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1751.98,
   "z": 3492.37,
   "y": 146.33,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1749.41,
   "z": 3495.43,
   "y": 146.91,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1746.84,
   "z": 3498.5,
   "y": 147.36,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1744.27,
   "z": 3501.56,
   "y": 147.53,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1741.7,
   "z": 3504.63,
   "y": 146.91,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1739.13,
   "z": 3507.69,
   "y": 146.06,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1731.42,
   "z": 3516.89,
   "y": 146.03,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1723.7,
   "z": 3526.08,
   "y": 146.15,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1715.99,
   "z": 3535.27,
   "y": 146.27,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1708.28,
   "z": 3544.47,
   "y": 146.39,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1700.57,
   "z": 3553.66,
   "y": 146.51,
   "width": 6.2,
   "camber": 0.003
  },
  {
   "x": -1693.03,
   "z": 3563,
   "y": 146.63,
   "width": 6.2,
   "camber": 0.011
  },
  {
   "x": -1686.33,
   "z": 3572.94,
   "y": 146.75,
   "width": 6.2,
   "camber": 0.019
  },
  {
   "x": -1681.15,
   "z": 3583.75,
   "y": 146.87,
   "width": 6.2,
   "camber": 0.021
  },
  {
   "x": -1677.77,
   "z": 3595.25,
   "y": 146.99,
   "width": 6.2,
   "camber": 0.021
  },
  {
   "x": -1676.26,
   "z": 3607.14,
   "y": 147.11,
   "width": 6.2,
   "camber": 0.021
  },
  {
   "x": -1676.66,
   "z": 3619.12,
   "y": 147.23,
   "width": 6.2,
   "camber": 0.02
  },
  {
   "x": -1678.88,
   "z": 3630.91,
   "y": 147.34,
   "width": 6.2,
   "camber": 0.013
  },
  {
   "x": -1682.25,
   "z": 3642.42,
   "y": 147.42,
   "width": 6.2,
   "camber": 0.004
  },
  {
   "x": -1685.96,
   "z": 3653.84,
   "y": 147.48,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1689.67,
   "z": 3665.25,
   "y": 147.51,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1693.38,
   "z": 3676.66,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1697.08,
   "z": 3688.07,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1700.79,
   "z": 3699.49,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1704.5,
   "z": 3710.9,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1708.21,
   "z": 3722.31,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1711.92,
   "z": 3733.72,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1715.63,
   "z": 3745.13,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1719.34,
   "z": 3756.55,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1723.04,
   "z": 3767.96,
   "y": 147.52,
   "width": 6.2,
   "camber": -0.001
  },
  {
   "x": -1726.63,
   "z": 3779.41,
   "y": 147.52,
   "width": 6.2,
   "camber": -0.004
  },
  {
   "x": -1729.9,
   "z": 3790.96,
   "y": 147.52,
   "width": 6.2,
   "camber": -0.006
  },
  {
   "x": -1732.68,
   "z": 3802.63,
   "y": 147.52,
   "width": 6.2,
   "camber": -0.007
  },
  {
   "x": -1734.83,
   "z": 3814.43,
   "y": 147.52,
   "width": 6.2,
   "camber": -0.007
  },
  {
   "x": -1736.34,
   "z": 3826.34,
   "y": 147.52,
   "width": 6.2,
   "camber": -0.007
  },
  {
   "x": -1737.19,
   "z": 3838.31,
   "y": 147.52,
   "width": 6.2,
   "camber": -0.007
  },
  {
   "x": -1737.39,
   "z": 3850.3,
   "y": 147.52,
   "width": 6.2,
   "camber": -0.007
  },
  {
   "x": -1736.96,
   "z": 3862.29,
   "y": 147.52,
   "width": 6.2,
   "camber": -0.005
  },
  {
   "x": -1736.06,
   "z": 3874.26,
   "y": 147.52,
   "width": 6.2,
   "camber": -0.003
  },
  {
   "x": -1734.89,
   "z": 3886.2,
   "y": 147.52,
   "width": 6.2,
   "camber": -0.001
  },
  {
   "x": -1733.64,
   "z": 3898.14,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1732.39,
   "z": 3910.07,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1731.14,
   "z": 3922.01,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1729.88,
   "z": 3933.94,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1729.15,
   "z": 3940.9,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1728.73,
   "z": 3944.88,
   "y": 147.26,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1728.32,
   "z": 3948.86,
   "y": 146.78,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1727.9,
   "z": 3952.84,
   "y": 146.64,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1727.48,
   "z": 3956.82,
   "y": 147.01,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1727.06,
   "z": 3960.79,
   "y": 147.45,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1725.81,
   "z": 3972.73,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1724.56,
   "z": 3984.66,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1723.3,
   "z": 3996.6,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1722.05,
   "z": 4008.53,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1720.8,
   "z": 4020.47,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1719.54,
   "z": 4032.4,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1718.29,
   "z": 4044.33,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1717.04,
   "z": 4056.27,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1715.78,
   "z": 4068.2,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1714.53,
   "z": 4080.14,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1713.28,
   "z": 4092.07,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1712.03,
   "z": 4104.01,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1710.77,
   "z": 4115.94,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1709.52,
   "z": 4127.87,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1708.27,
   "z": 4139.81,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1707.01,
   "z": 4151.74,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1705.76,
   "z": 4163.68,
   "y": 147.52,
   "width": 6.2,
   "camber": 0
  },
  {
   "x": -1704.52,
   "z": 4175.61,
   "y": 147.52,
   "width": 6.2,
   "camber": 0.004
  },
  {
   "x": -1703.59,
   "z": 4187.58,
   "y": 147.52,
   "width": 6.2,
   "camber": 0.01
  },
  {
   "x": -1703.58,
   "z": 4199.57,
   "y": 147.52,
   "width": 6.2,
   "camber": 0.016
  },
  {
   "x": -1705.02,
   "z": 4211.48,
   "y": 147.52,
   "width": 6.2,
   "camber": 0.017
  },
  {
   "x": -1708.01,
   "z": 4223.09,
   "y": 147.52,
   "width": 6.2,
   "camber": 0.014
  },
  {
   "x": -1712.19,
   "z": 4234.33,
   "y": 147.52,
   "width": 6.2,
   "camber": 0.007
  },
  {
   "x": -1716.97,
   "z": 4245.34,
   "y": 147.52,
   "width": 6.2,
   "camber": 0.002
  },
  {
   "x": -1721.85,
   "z": 4256.31,
   "y": 147.52,
   "width": 6.6,
   "camber": 0
  },
  {
   "x": -1726.73,
   "z": 4267.27,
   "y": 147.52,
   "width": 6.6,
   "camber": 0
  },
  {
   "x": -1731.61,
   "z": 4278.23,
   "y": 147.52,
   "width": 6.6,
   "camber": 0
  },
  {
   "x": -1736.49,
   "z": 4289.19,
   "y": 147.52,
   "width": 6.6,
   "camber": 0
  },
  {
   "x": -1741.38,
   "z": 4300.15,
   "y": 147.52,
   "width": 6.6,
   "camber": 0
  },
  {
   "x": -1746.26,
   "z": 4311.12,
   "y": 147.52,
   "width": 6.6,
   "camber": 0
  },
  {
   "x": -1751.14,
   "z": 4322.08,
   "y": 147.52,
   "width": 6.6,
   "camber": 0
  },
  {
   "x": -1756.02,
   "z": 4333.04,
   "y": 147.52,
   "width": 6.6,
   "camber": 0
  },
  {
   "x": -1760.9,
   "z": 4344,
   "y": 147.52,
   "width": 6.6,
   "camber": 0
  },
  {
   "x": -1765.79,
   "z": 4354.96,
   "y": 147.52,
   "width": 6.6,
   "camber": 0
  },
  {
   "x": -1770.67,
   "z": 4365.93,
   "y": 147.52,
   "width": 6.6,
   "camber": 0
  },
  {
   "x": -1775.55,
   "z": 4376.89,
   "y": 147.52,
   "width": 6.6,
   "camber": 0
  },
  {
   "x": -1780.43,
   "z": 4387.85,
   "y": 147.52,
   "width": 6.6,
   "camber": 0
  },
  {
   "x": -1782.26,
   "z": 4391.96,
   "y": 147.52,
   "width": 6.6,
   "camber": 0
  }
 ],
 "surfaces": [
  {
   "from": 0,
   "to": 3321.5,
   "surface": "gravel"
  },
  {
   "from": 3321.5,
   "to": 3700,
   "surface": "tarmac"
  },
  {
   "from": 3700,
   "to": 5804.5,
   "surface": "gravel"
  }
 ],
 "patches": [
  {
   "from": 1153,
   "to": 1178,
   "surface": "wet"
  },
  {
   "from": 3770,
   "to": 3786,
   "surface": "water"
  },
  {
   "from": 3899,
   "to": 3937,
   "surface": "mud"
  },
  {
   "from": 4107,
   "to": 4177,
   "surface": "loose"
  },
  {
   "from": 4321.5,
   "to": 4351.5,
   "surface": "mud"
  },
  {
   "from": 4649.5,
   "to": 4684.5,
   "surface": "mud"
  },
  {
   "from": 5083,
   "to": 5103,
   "surface": "wet"
  }
 ],
 "zones": [
  {
   "from": 0,
   "to": 2028,
   "type": "forest"
  },
  {
   "from": 2028,
   "to": 3321.5,
   "type": "open"
  },
  {
   "from": 3321.5,
   "to": 3700,
   "type": "hamlet"
  },
  {
   "from": 3700,
   "to": 5804.5,
   "type": "forest"
  }
 ],
 "startDistance": 30,
 "splits": [
  1945,
  3750
 ],
 "finishDistance": 5426,
 "stopDistance": 5755,
 "props": [
  {
   "type": "arch",
   "s": 30,
   "text": "START"
  },
  {
   "type": "board",
   "s": 1945,
   "offset": -5.5,
   "text": "SPLIT 1"
  },
  {
   "type": "board",
   "s": 3750,
   "offset": -5.5,
   "text": "SPLIT 2"
  },
  {
   "type": "board",
   "s": 5325.5,
   "offset": -5.5,
   "text": "100"
  },
  {
   "type": "board",
   "s": 5375.5,
   "offset": -5.5,
   "text": "50"
  },
  {
   "type": "arch",
   "s": 5425.5,
   "text": "FLYING FINISH"
  },
  {
   "type": "board",
   "s": 5754.5,
   "offset": -5.5,
   "text": "STOP"
  },
  {
   "type": "tape",
   "s": 3370.75,
   "to": 3378.75,
   "offset": 0
  },
  {
   "type": "bale",
   "s": 3374.75,
   "offset": 0
  },
  {
   "type": "tape",
   "s": 3517.25,
   "to": 3525.25,
   "offset": 0
  },
  {
   "type": "bale",
   "s": 3521.25,
   "offset": 0
  },
  {
   "type": "bridge",
   "s": 3951,
   "to": 3983
  },
  {
   "type": "post",
   "s": 3403,
   "offset": -6.5,
   "text": "house"
  },
  {
   "type": "post",
   "s": 3423,
   "offset": 6.5,
   "text": "house"
  },
  {
   "type": "post",
   "s": 3443,
   "offset": -6.5,
   "text": "house"
  },
  {
   "type": "post",
   "s": 3463,
   "offset": 6.5,
   "text": "house"
  },
  {
   "type": "post",
   "s": 3483,
   "offset": -6.5,
   "text": "house"
  },
  {
   "type": "post",
   "s": 3503,
   "offset": 6.5,
   "text": "house"
  },
  {
   "type": "rock",
   "s": 4730,
   "offset": 4.6,
   "scale": 1.2
  },
  {
   "type": "rock",
   "s": 1743.75,
   "offset": -4.8,
   "scale": 1.4
  },
  {
   "type": "log",
   "s": 1263,
   "offset": -5
  },
  {
   "type": "barrier",
   "s": 2577,
   "to": 2612,
   "offset": 5.5
  },
  {
   "type": "spectators",
   "s": 2542,
   "offset": 14
  },
  {
   "type": "spectators",
   "s": 1743.75,
   "offset": 16
  },
  {
   "type": "spectators",
   "s": 3374.75,
   "offset": -12
  },
  {
   "type": "spectators",
   "s": 3758,
   "offset": -13
  },
  {
   "type": "fence",
   "s": 3348,
   "to": 3624.5,
   "offset": 8.5
  },
  {
   "type": "fence",
   "s": 3348,
   "to": 3624.5,
   "offset": -8.5
  },
  {
   "type": "fence",
   "s": 2801.5,
   "to": 3141.5,
   "offset": -10
  },
  {
   "type": "fence",
   "s": 2227.5,
   "to": 2522,
   "offset": 12
  },
  {
   "type": "rock",
   "s": 1069,
   "offset": -4.4,
   "scale": 1.5
  },
  {
   "type": "rock",
   "s": 1118,
   "offset": 5.6,
   "scale": 1.7
  },
  {
   "type": "rock",
   "s": 1855.5,
   "offset": 4.6,
   "scale": 1.6
  },
  {
   "type": "rock",
   "s": 2417.5,
   "offset": -5.4,
   "scale": 1.8
  },
  {
   "type": "rock",
   "s": 3061.5,
   "offset": 6,
   "scale": 2
  },
  {
   "type": "rock",
   "s": 3065.5,
   "offset": 7.2,
   "scale": 1.3
  },
  {
   "type": "rock",
   "s": 4192,
   "offset": -4.6,
   "scale": 1.5
  },
  {
   "type": "rock",
   "s": 4788.5,
   "offset": 5.4,
   "scale": 1.6
  },
  {
   "type": "rock",
   "s": 4890.5,
   "offset": -5.6,
   "scale": 1.8
  }
 ],
 "roadFeatures": [
  {
   "type": "potholes",
   "from": 1145,
   "to": 1185,
   "count": 10,
   "water": 0.7,
   "size": 0.9,
   "depth": 0.12
  },
  {
   "type": "ruts",
   "from": 1594,
   "to": 1955,
   "depth": 0.13
  },
  {
   "type": "potholes",
   "from": 1768.5,
   "to": 1808.5,
   "count": 7,
   "water": 0.2,
   "size": 0.8,
   "depth": 0.13
  },
  {
   "type": "washout",
   "s": 2921.5,
   "depth": 0.32,
   "length": 2.6,
   "skew": 0.35
  },
  {
   "type": "potholes",
   "from": 3358,
   "to": 3604.5,
   "count": 30,
   "water": 0.35,
   "size": 0.75,
   "depth": 0.08
  },
  {
   "type": "washout",
   "s": 3718,
   "depth": 0.28,
   "length": 2.2,
   "skew": -0.4
  },
  {
   "type": "ruts",
   "from": 3895,
   "to": 3941,
   "depth": 0.16
  },
  {
   "type": "potholes",
   "from": 3901,
   "to": 3935,
   "count": 9,
   "water": 0.85,
   "size": 1,
   "depth": 0.14
  },
  {
   "type": "ruts",
   "from": 4316.5,
   "to": 4356.5,
   "depth": 0.12
  },
  {
   "type": "potholes",
   "from": 4323.5,
   "to": 4349.5,
   "count": 5,
   "water": 0.8,
   "size": 0.9,
   "depth": 0.12
  },
  {
   "type": "washout",
   "s": 4475.5,
   "depth": 0.35,
   "length": 2.8,
   "skew": 0.3
  },
  {
   "type": "potholes",
   "from": 5043,
   "to": 5113,
   "count": 14,
   "water": 0.45,
   "size": 0.85,
   "depth": 0.12
  },
  {
   "type": "washout",
   "s": 5395.5,
   "depth": 0.25,
   "length": 2.2,
   "skew": -0.25
  }
 ],
 "notes": [
  {
   "s": 4740,
   "add": [
    "dont_cut"
   ]
  },
  {
   "s": 1743.75,
   "add": [
    "dont_cut"
   ]
  },
  {
   "s": 3951,
   "insert": [
    "caution",
    "bridge"
   ]
  },
  {
   "s": 2552,
   "add": [
    "double_caution"
   ]
  }
 ],
 "terrain": {
  "size": 6000,
  "amplitude": 38,
  "roughness": 0.55,
  "treeDensity": 1
 }
}
